t<template>
  <div class="container">
        <el-tabs v-model="activeName" @tab-click="tabClick" class="tabsPart">
            <el-tab-pane label="一等奖" name="1">
                <div v-loading="loading1" class="tabContent">
                    <el-row :gutter="20" class="workContent" >
                        <el-col :span="4" class="workItem" v-for="(item,index) in firstArr" :key="index">
                            <div class="itemC" @click="clickWorkItem(item)">
                                <div class="imgPart">
                                    <img :src="imgBaseUrl+ item.icon" alt="">
                                </div>
                                <div class="textPart">
                                    <div class="workTitle" >{{item.title}}</div>
                                    <div class="workBy">By: {{item.contacter}}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-tab-pane>
            <el-tab-pane label="二等奖" name="2">
                <div v-loading="loading2" class="tabContent">
                    <el-row :gutter="20" class="workContent" >
                        <el-col :span="4" class="workItem" v-for="(item,index) in secondArr" :key="index">
                            <div class="itemC" @click="clickWorkItem(item)">
                                <div class="imgPart">
                                    <img :src="imgBaseUrl+ item.icon" alt="">
                                </div>
                                <div class="textPart">
                                    <div class="workTitle" >{{item.title}}</div>
                                    <div class="workBy">By: {{item.contacter}}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-tab-pane>
            <el-tab-pane label="三等奖" name="3">
                <div v-loading="loading3" class="tabContent">
                    <el-row :gutter="20" class="workContent" >
                        <el-col :span="4" class="workItem" v-for="(item,index) in thirdArr" :key="index">
                            <div class="itemC" @click="clickWorkItem(item)">
                                <div class="imgPart">
                                    <img :src="imgBaseUrl+ item.icon" alt="">
                                </div>
                                <div class="textPart">
                                    <div class="workTitle" >{{item.title}}</div>
                                    <div class="workBy">By: {{item.contacter}}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-pagination
                        style="margin:0 auto; margin-top:25px;"
                        v-show="workTotal3>0"
                        :total="workTotal3"
                        :current-page.sync="currentPage3"
                        :page-size="5"
                        layout="total,  prev, pager, next, jumper"
                        @current-change="getThirdWork"
                    />
                </div>
            </el-tab-pane>
            <el-tab-pane label="优秀奖" name="4">
                <div v-loading="loading4" class="tabContent">
                    <el-row :gutter="20" class="workContent" >
                        <el-col :span="4" class="workItem" v-for="(item,index) in fourArr" :key="index">
                            <div class="itemC" @click="clickWorkItem(item)">
                                <div class="imgPart">
                                    <img :src="imgBaseUrl+ item.icon" alt="">
                                </div>
                                <div class="textPart">
                                    <div class="workTitle" >{{item.title}}</div>
                                    <div class="workBy">By: {{item.contacter}}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-pagination
                        style="margin:0 auto; margin-top:25px;"
                        v-show="workTotal4>0"
                        :total="workTotal4"
                        :current-page.sync="currentPage4"
                        :page-size="5"
                        layout="total,  prev, pager, next, jumper"
                        @current-change="getFourWork"
                    />
                </div>
            </el-tab-pane>
        </el-tabs>
    
  </div>
</template>

<script>
import { getAction, postAction, uploadImage } from '@/request/http'//引入封装的get post方法
export default {
  name: "prizesWork",
  components:{
  },
  dicts: ['sys_yes_no'],
  data() {
    return {
        activeName:'1',
        firstArr:[],
        secondArr:[],
        thirdArr:[],
        fourArr:[],
        currentPage3:1,
        workTotal3:0,
        currentPage4:1,
        workTotal4:0,
        loading1:false,
        loading2:false,
        loading3:false,
        loading4:false,
        url:{
           workList:'/list',
        },
        imgBaseUrl:window._CONFIG['uploadURL'],
        prizesTotal:'',
    
     
    };
  },
  created() {
  },
  mounted(){
    this.tabClick()
    this.getPrizesTotal()
    
  },
  methods: {
    tabClick(tab, event) {
       console.log(this.activeName);
       switch(this.activeName){
            case '4':
                this.getPrizesWork(1)
                break;
            case '3':
                this.getPrizesWork(2)
                break;
            case '2':
                this.getPrizesWork(3)
                break;
            default:
                this.getPrizesWork(4)
       }
    },

    getPrizesTotal(){
        var params = {
            prizesArr:'1,2,3,4',
        }
        getAction(this.url.workList, params)
        .then(res => {
          if(res.data.code==200){
            this.prizesTotal = res.data.total;
            this.$emit('givePrizesTotal', this.prizesTotal)
          }else{
            this.msgError(res.data.msg);
          }
        });

    },
   
    /** 查询参赛作品列表 */
    getPrizesWork(num) {
        if(num==4){
            this.getFirstWork()
        }else if(num==3){
            this.getSecondWork()
        }else if(num==2){
            this.getThirdWork()
        }else if(num==1){
            this.getFourWork()
        }
    },

    getFirstWork(){
        var params = {
            prizes:'4',
            pageNum: 1,
            pageSize:5,
        }
        getAction(this.url.workList, params)
        .then(res => {
          if(res.data.code==200){
            this.firstArr = res.data.rows;
          }else{
            this.msgError(res.data.msg);
          }
        });
    },
    getSecondWork(){
        var params = {
            prizes:'3',
            pageNum: 1,
            pageSize:5,
        }
        getAction(this.url.workList, params)
        .then(res => {
          if(res.data.code==200){
            this.secondArr = res.data.rows;
          }else{
            this.msgError(res.data.msg);
          }
        });
    },
    getThirdWork(){
        var params = {
            prizes:'2',
            pageNum: this.currentPage3,
            pageSize:5,
        }
        getAction(this.url.workList, params)
        .then(res => {
          if(res.data.code==200){
            this.thirdArr = res.data.rows;
            this.workTotal3 = res.data.total;
          }else{
            this.msgError(res.data.msg);
          }
        });
    },
    getFourWork(){
        var params = {
            prizes:'1',
            pageNum: this.currentPage4,
            pageSize:5,
        }
        getAction(this.url.workList, params)
        .then(res => {
          if(res.data.code==200){
            this.fourArr = res.data.rows;
            this.workTotal4 = res.data.total;
          }else{
            this.msgError(res.data.msg);
          }
        });
    },


    //参赛作品详情
    clickWorkItem(item){
        this.$router.push({ path: '/workDetail', query:{view:'2', workId:item.id}})
    }
  
    
   
    

  }
};
</script>
<style scoped>
.container{
  width: 100%;
}
.tabsPart /deep/.el-tabs__item{
    font-size: 24px;
    line-height: 24px;
    padding: 0 35px;
}
.tabsPart /deep/.el-tabs__active-bar{
    height: 4px;
}
.workContent{
    display: flex;
    width: 100%;
    margin-top: 20px;
}
.workItem{
    padding: 0px;
}
.imgPart img{
    width: 100%;
    /* height: 200px; */
    border-radius: 8px 8px 0px 0px;
}
.workItem .textPart{
    text-align: left;
    font-size: 14px;
    line-height: 28px;
    padding: 0 10px;
    color: #fff;
}
.workTitle{
    font-size: 16px;
    white-space:nowrap;
    text-overflow: ellipsis;
    overflow:hidden;
}
.workBy{
    white-space:nowrap;
    text-overflow: ellipsis;
    overflow:hidden;
}
.itemC{
    width: 90%;
    margin: 0 auto;
    background: #61c5ff;
    border-radius: 1%;
    cursor: pointer;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 20%);
}
.tabContent{
    min-height: 340px;
}

</style>
